module.exports = __webpack_public_path__ + "static/media/Hydraulics-Motors-Comparison@3x-100.57ba4a90.png";